import { render, staticRenderFns } from "./CoozzyClipBoardIcon.vue?vue&type=template&id=46f37f84&scoped=true"
import script from "./CoozzyClipBoardIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyClipBoardIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyClipBoardIcon.vue?vue&type=style&index=0&id=46f37f84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f37f84",
  null
  
)

export default component.exports